import { Helmet } from 'react-helmet-async';
import { seoDefaults, type SeoProps } from './seo.config';

export function SEO({
  title,
  description,
  canonicalUrl,
  ogImage,
  structuredData,
  noindex,
}: SeoProps): JSX.Element {
  const pageTitle = title
    ? `${title} · ${seoDefaults.siteName}`
    : seoDefaults.defaultTitle;
  const pageDesc = description ?? seoDefaults.defaultDescription;
  const image = ogImage ?? seoDefaults.defaultOgImage;
  const structured = Array.isArray(structuredData)
    ? structuredData
    : structuredData
    ? [structuredData]
    : [];

  return (
    <Helmet prioritizeSeoTags>
      <html lang="pt-PT" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow" />}
      <meta property="og:site_name" content={seoDefaults.siteName} />
      <meta property="og:locale" content={seoDefaults.locale} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}
      <meta name="twitter:card" content={seoDefaults.twitterCard} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={image} />
      {structured.map((data, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
}
